// extracted by mini-css-extract-plugin
export default {"dropdownContainer":"ProfileCard_dropdownContainer__RUAoY","openDown":"ProfileCard_openDown__8V-7W","info":"ProfileCard_info__9pqxr","exitButton":"ProfileCard_exitButton__XMB4a"};